import { prefixerC } from './common'

export const ROUTE_CONFIGURAR_TIPO_DEPRECIACION = prefixerC('tipo-depreciacion')

export const ROUTE_CONFIGURAR_NIVEL_APROBACION_SOLICITUD_TRANSFERENCIA = prefixerC(
    'nivel-aprobacion-solicitud-transferencia'
)

export const ROUTE_PERMISOS_TIPOS_ACTIVOS_FIJOS = prefixerC('permisos-activos-fijos')
